import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logo_myculture.png'
import _imports_1 from '@/assets/icons/email_24px.png'
import _imports_2 from '@/assets/image/CreateAccount/logo_google.png'
import _imports_3 from '@/assets/image/CreateAccount/logo_microsoft.png'


const _withScopeId = n => (_pushScopeId("data-v-1753c204"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body flex-mid" }
const _hoisted_2 = { class: "card create-account" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Happily logo",
  style: {"margin-bottom":"4.4rem","width":"18rem"}
}, null, -1))
const _hoisted_4 = { class: "fw-900 fs-18" }
const _hoisted_5 = { class: "input-with-icon mt-16" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-left flex-mid" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon-20",
    alt: "email_24px"
  })
], -1))
const _hoisted_8 = { class: "center fs-14 mt-30 user-select-none" }
const _hoisted_9 = { class: "relative line-splite-page mt-32" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-mid line" }, null, -1))
const _hoisted_11 = { class: "absolute-mid or" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "logo google",
  class: "mr-26"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "logo microsoft",
  class: "mr-26"
}, null, -1))
const _hoisted_14 = { class: "center flex-mid link-terms" }
const _hoisted_15 = { class: "mr-4" }
const _hoisted_16 = {
  class: "link-text",
  href: "https://myculture.happily.ai/terms-and-conditions",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("createAccount.Log_in_to")), 1),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(`input-44-0000000d ${_ctx.validateStyle(_ctx.formValidate.email)}`),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
            type: "email",
            placeholder: _ctx.$t('placeholder.Work_email'),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
          }, null, 42, _hoisted_6), [
            [_vModelText, _ctx.form.email]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["btn-create flex-mid mt-16", `${_ctx.disableButton ? 'btn-progress' : 'btn-primary'}`]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
        }, _toDisplayString(_ctx.$t("createAccount.Log_in")), 3),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("createAccount.Do_not_have")), 1),
          (_ctx.$router.currentRoute.value.meta.lang == 'TH')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'Signup_th' }))),
                class: "link-text ml-4"
              }, _toDisplayString(_ctx.$t("createAccount.Sign_up")), 1))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'Signup' }))),
                class: "link-text ml-4"
              }, _toDisplayString(_ctx.$t("createAccount.Sign_up")), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("createAccount.OR")), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClickAuthProvider('google'))),
        class: "btn-outside-login flex-center mt-32"
      }, [
        _hoisted_12,
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("createAccount.Continue_with_Google")), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleClickAuthProvider('microsoft'))),
        class: "btn-outside-login flex-center mt-16"
      }, [
        _hoisted_13,
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("createAccount.Continue_with_Microsoft")), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("createAccount.By_signing_up")), 1),
        _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("createAccount.Terms_and_Conditions")), 1)
      ])
    ])
  ]))
}